// extracted by mini-css-extract-plugin
export default {"detail":"style_detail__NauSc","content":"style_content__4412-","step":"style_step__itTPZ","arrowDown":"style_arrowDown__-qLvr"};